<template>
  <div class="modal-small" :class="classModifier">
    <div v-if="overlay" class="modal-small__overlay" @click="close"></div>
    <div class="modal-small__wrap">
      <div class="modal-small__header">
        <slot name="header"></slot>
        <button class="modal-small__close" v-if="closeButton" @click="close"></button>
      </div>
      <div class="modal-small__content">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script src="./small.js"></script>
<style src="./small.scss" lang="scss"></style>
